// # #############################################
// # Title : Spark Lines
// # Authors : Atul
// # Last Modified : Dhruv, 21th Septembee, Disabled Chart animations
// # Version : 19.10.03
// # Description :  SParklines for your brand
// # ############################################

import React, {
    Component
} from "react";
import Highcharts from "highcharts";
// import CircularProgress from "@material-ui/core/CircularProgress";
import "../css/SyncSparks.css";
import { abbreviateNumber } from "../utils/helperFunction";
require("highcharts/highcharts-more.js")(Highcharts);
var moment = require('moment');


class Syncsparks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datasets: [],
            divRefs: [],
            strData: []
        };
    }

    componentWillUnmount() {
        this.props.unsubscribe_ns('strategyData', data => {
        });
    }

    componentDidMount() {

        let divRefs = [];

        [0, 1, 2, 3, 4].forEach((d, i) => {
            var chartDiv = document.createElement('div');
            chartDiv.className = `chart chart_${i}`;
            document.getElementById('sparklines').appendChild(chartDiv);

            divRefs.push(chartDiv)
        })

        this.setState({
            divRefs: divRefs
        })

        this.props.subscribe_ns('strategyData', data => {
            this.setState({
                datasets: data
            })
        });

        this.addEvents();

    }

    loadSparkLine = () => {
        /*
        The purpose of this demo is to demonstrate how multiple charts on the same page
        can be linked through DOM and Highcharts events and API methods. It takes a
        standard Highcharts config with a small variation for each data set, and a
        mouse/touch event handler to bind the charts together.
        
        * Override the reset function, we don't need to hide the tooltips and
        * crosshairs.
        */

        Highcharts.Pointer.prototype.reset = function () {
            return undefined;
        };

        /**
         * Highlight a point by showing tooltip, setting hover state and draw crosshair
         */
        Highcharts.Point.prototype.highlight = function (event) {
            event = this.series.chart.pointer.normalize(event);
            this.onMouseOver(); // Show the hover marker
            this.series.chart.tooltip.refresh(this); // Show the tooltip
            this.series.chart.xAxis[0].drawCrosshair(event, this); // Show the crosshair
        };

        /**
         * Synchronize zooming through the setExtremes event handler.
         */
        function syncExtremes(e) {
            var thisChart = this.chart;

            if (e.trigger !== 'syncExtremes') { // Prevent feedback loop
                Highcharts.each(Highcharts.charts, function (chart) {
                    if (chart !== thisChart) {
                        if (chart.xAxis[0].setExtremes) { // It is null while updating
                            chart.xAxis[0].setExtremes(
                                e.min,
                                e.max,
                                undefined,
                                false, {
                                trigger: 'syncExtremes'
                            }
                            );
                        }
                    }
                });
            }
        }

        // Get the data. The contents of the data file can be viewed at
        if (Object.values(this.state.datasets).length > 4 && this.state.datasets[0].info.length > 0) {
            this.state.datasets.forEach((dataset, i) => {

                let seriesdata;
                let type, unit, decimal, title = "dummy", suffix;

                for (let index = 0; index < dataset.info.length; index++) {

                    if (dataset.info[index].account === "YourBrand" || dataset.info[index].account === "Your Brand") {

                        if (dataset.name === "Price") {
                            type = "line"
                            unit = `$ `
                            suffix = ``
                            decimal = 1
                            title = dataset.name + " ($)"

                        }
                        else if (dataset.name === "Promotion") {
                            type = "line"
                            unit = `$ `
                            suffix = ``
                            decimal = 0
                            title = dataset.name + " ($/Week)"
                        }
                        else if (dataset.name === "Revenue") {
                            unit = `$ `
                            decimal = 0
                            suffix = ``
                            title = dataset.name + " ($)"
                        }
                        else if (dataset.name === "Sales") {
                            type = "line"
                            unit = ``
                            decimal = 0
                            suffix = ``
                            title = `Units (count)`
                        }
                        else if (dataset.name === "Market Share") {
                            type = "line"
                            unit = ``
                            suffix = ` %`
                            decimal = 1
                            title = dataset.name + " ($)"
                        }

                        let dataIn = dataset.info[index].data;

                        dataIn.forEach((d) => {
                            d[0] = parseInt(d[0])
                        })

                        seriesdata = {
                            animation: {
                                duration: 0
                            },
                            data: dataIn,
                            name: "Your Brand",
                            title: title,
                            type: type,
                            fillOpacity: 0.2,
                            color: "#2F32D1",
                            tooltip: {
                                valueDecimals: decimal,
                                valuePrefix: ` ${unit}`,
                                valueSuffix: ` ${suffix}`
                            },
                        };

                    }
                }

                if (title !== "dummy") {
                    Highcharts.chart(this.state.divRefs[i], {
                        chart: {
                            marginLeft: 50, // Keep all charts left aligned
                            spacingRight: 40,
                            spacingTop: 20,
                            spacingBottom: 20,
                            shadow: true,
                            borderRadius: '5px',
                            animation: false,
                        },
                        title: {
                            text: title,
                            align: 'left',
                            margin: 10,
                            x: 30,
                            floating: false,
                            style: { "fontSize": "14px" }
                        },
                        credits: {
                            enabled: false
                        },
                        legend: {
                            enabled: false
                        },
                        xAxis: {
                            visible: true,
                            allowDecimals: false,
                            crosshair: true,
                            events: {
                                setExtremes: syncExtremes
                            },
                            labels: {
                                format: '{value}'
                            },
                            // tickPositioner: function() {
                            //     this.tickPositions.push(this.getExtremes().dataMax);
                            // }
                        },
                        yAxis: {
                            title: {
                                text: null
                            },
                            gridLineWidth: 0,
                            tickWidth: 1,
                            offset: -5,
                            min: 0,

                        },
                        tooltip: {
                            shared: true,
                            crosshairs: true,
                            valueDecimals: 1,
                            borderColor: "#7DAD24",

                            //For tooltip header showing Weeks and Days
                            //For tooltip header showing Weeks and Days
                            formatter: function (tooltip) {
                                let header, day, utcSeconds, d, currDate, week, start;

                                if (sessionStorage.getItem("scenarioDetail")) {
                                    start = new Date(JSON.parse(sessionStorage.getItem("scenarioDetail"))[0].startTime * 1000).setFullYear(2020) / 1000
                                }
                                else {
                                    start = new Date(JSON.parse(sessionStorage.getItem("simSettings")).accordians[0].content[2].selectedValue).setFullYear(2020) / 1000
                                }


                                if (dataset.name === "Promotion") {
                                    week = (this.x / 7) % 1 !== 0 ? Math.floor(this.x / 7) + 1 : Math.floor(this.x / 7)
                                    utcSeconds = start + (86400) * (week - 1) * 7;
                                    d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                                    d.setUTCSeconds(utcSeconds);
                                    currDate = new Date(d);

                                    header = `<span style="color: blue;"> Week ${week} -- ${moment(currDate).format('l')}</span><br/>`
                                }
                                else if (dataset.name === "Price") {
                                    day = this.x
                                    utcSeconds = start + (86400) * (day - 1);
                                    d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                                    d.setUTCSeconds(utcSeconds);
                                    currDate = new Date(d);

                                    header = `<span style="color: blue;"> Day ${day} - ${moment(currDate).format('l')} </span><br/>`
                                }
                                else {
                                    day = this.x
                                    utcSeconds = start + (86400) * (day - 1);
                                    d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                                    d.setUTCSeconds(utcSeconds);
                                    currDate = new Date(d);
                                    header = `<span style="color: blue;"> Day ${day} - ${moment(currDate).format('l')}</span><br/>`
                                }

                                let bodyText = [], text;

                                this.points.forEach(function (element) {
                                    text = `<span style="color:${element.series.color}">●</span> ${element.series.userOptions.name}: <b> ${element.series.userOptions.tooltip.valuePrefix} ${abbreviateNumber(element.y.toFixed(element.series.userOptions.tooltip.valueDecimals))} ${element.series.userOptions.tooltip.valueSuffix}</b><br/>`
                                    bodyText.push(text)
                                })
                                return header + bodyText.join('');
                            }
                        },
                        plotOptions: {
                            lineWidth: 1,
                            series: {
                                animation: false,
                                marker: {
                                    radius: 1
                                }
                            }
                        },
                        series: [seriesdata]
                    });
                }
            });
        }
    }

    addEvents() {
        ['mousemove', 'touchmove', 'touchstart', 'mouseout'].forEach(function (eventType) {
            document.getElementById('sparklines').addEventListener(
                eventType,
                function (e) {
                    for (let i = 0; i < Highcharts.charts.length; ++i) {
                        let chart = Highcharts.charts[i];
                        if (chart && (chart.renderTo.classList[0] === "chart" || chart.renderTo.id === "container") ){

                            let event = chart.pointer.normalize(e); // Find coordinates within the chart
                            let point;
                            for (let j = 0; j < chart.series.length && !point; ++j) {
                                point = chart.series[j].searchPoint(event, true);
                            }
                            if (!point) {
                            } else {
                                if (e.type === "mousemove") {
                                    point.onMouseOver();
                                    chart.xAxis[0].drawCrosshair(event, point);
                                } else if (e.type === "mouseout") {
                                    point.onMouseOut();
                                    chart.tooltip.hide(point);
                                    chart.xAxis[0].hideCrosshair();
                                }
                            }
                        }     
                    }
                }
            );
        });
    }

    render() {
        if (Object.values(this.state.datasets).length > 4 && this.state.datasets[0].info.length > 0) {
            this.loadSparkLine();
            return (
                <React.Fragment >
                    <span className="InputTrends" >
                        <span className="leftInput">Policy Changes</span>
                        <span className="rightInput">At day level</span>
                    </span>
                    <span className="OutputTrends">
                        <span className="leftInput" > Sales and Consumption Trends</span>
                        <span className="rightInput">At day level</span>
                    </span>
                </React.Fragment>
            );
        }
        else if (sessionStorage.getItem("simStarted") === "true") {
            return (
                <div className="graphLoader" >
                    {/* <CircularProgress size={80} /> */}
                    <div id={"loaderContainerGraphs"}>
                        <div class="lds-facebook-graphs"><div></div><div></div><div></div></div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="noSimText" >
                    {/* Start simulation in order to view results */}
                    <div id={"loaderContainerSpark"}>
                        <div class="lds-facebook"><div></div><div></div><div></div></div>
                    </div>
                </div>
            );
        }
    }
}

export default Syncsparks;